import React from 'react';
import './index.scss';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer>
      <div>
        <a href="https://www.tencent.com/zh-cn" target="_blank" rel="noreferrer">
          关于腾讯
        </a>
        <div>Copyright &copy; 1998 - {year} Tencent Inc. All Rights Reserved.</div>
      </div>
    </footer>
  );
};

export default Footer;
